export const RESET = 'LABEL_LIST_RESET'
export const SET_ITEMS = 'LABEL_LIST_SET_ITEMS'
export const SET_ERROR = 'LABEL_LIST_SET_ERROR'
export const SET_VIEW = 'LABEL_LIST_SET_VIEW'
export const TOGGLE_LOADING = 'LABEL_LIST_TOGGLE_LOADING'
